import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { history } from '../history';
import { connect, useDispatch } from 'react-redux';
import { Link, Route, Router, Switch, useLocation } from 'react-router-dom';
import { ProgramConstant } from '../redux/reducers';
import { API } from '../config/api';
import { nFormat } from '../libs/string';
import RTTable from '../libs/table';
import { fetchData } from '../libs/db';

const Users = ({ user, allgroups, allusers }) => {

	const dispatch = useDispatch();

	const [t] = useTranslation(['translation']);
	const [ items, setItems ] = useState([]);
	const [ list, setList ] = useState([]);
	const [ process, setProcess ] = useState(false);
	const [ err, setErr ] = useState("");
	const [ search, setSearch ] = useState("");
	const [ partnerOnly, setPartnerOnly ] = useState("p");
	
	useEffect(() => {
		dispatch({ type : ProgramConstant.PAGE, item : {
			label : t("Accounts"),
			caption : t("Manage all accounts")
		}});
		if(search){
			setList(makeItems(allusers.filter(x => filter(x)).filter(x => x.name.indexOf(search) > -1)));
		}else{
			setList(makeItems(allusers.filter(x => filter(x))));
		}
	},[search, allusers, partnerOnly ])

	const filter = (x) => {
		if(partnerOnly === "p"){
			return x.groupId === user.partnerKey;
		}else if(partnerOnly === "l"){
			return x.groupId !== user.partnerKey;
		}else{
			return true;
		}
	}

	const makeItems = (showitems) => {
		return showitems.map(x => {
			const group = allgroups.find(g => g._id === x.groupId);
			return {...x, 
				groupname : group?.name, 
				countryCode : group?.countryCode
			};
		});
	}

	const headers = [
		{ value : "_id", label : t("Name"), css : "text-start", type : "USER" },
		{ link : "groupId", value : "groupname", label : t("Lab"), css : "text-start", hidden : partnerOnly },
        { value : "partnerId", label : t("Partner"), css : "text-start", type : "PARTNER" },
        { value : "countryCode", label : t("Country"), css : "text-start", type : "COUNTRY", hidden : partnerOnly },
        { value : "lastlogged", label : t("Last Login"), css : "text-center", type : "DATE" }
	]
	
  	return <div className="card">
		<div className="card-header">
			<div className="card-title">
				<div className="d-flex align-items-center position-relative my-1">
					<span className="svg-icon svg-icon-1 position-absolute ms-6">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
							<path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black"></path>
						</svg>
					</span>
					<input 
						type="text" 
						className="form-control form-control-solid w-250px ps-14" 
						placeholder="Search keyword" onChange={(e) => setSearch(e.target.value)} />
				</div>
			</div>
			<div className="card-toolbar">
				<span className="ms-4 text-gray-800">Total : {list && nFormat(list.length)}</span>
				<div className="btn-group ms-4" role="group">
				  <button type="button" onClick={() => setPartnerOnly('')} className={partnerOnly === "" ? "btn btn-sm btn-primary" : "btn btn-sm btn-secondary"}>{t("All")}</button>
				  <button type="button" onClick={() => setPartnerOnly('p')} className={partnerOnly === "p" ? "btn btn-sm btn-primary" : "btn btn-sm btn-secondary"}>{t("Partner")}</button>
				  <button type="button" onClick={() => setPartnerOnly('l')} className={partnerOnly === "l" ? "btn btn-sm btn-primary" : "btn btn-sm btn-secondary"}>{t("Lab")}</button>
				</div>
			</div>
		</div>
		<div className="card-body">
			<RTTable 
				rowkey={"_id"}
				headers={headers} 
				items={list} 
				loading={process} />
		</div>
	</div>
}

const mapState = (state) => {
	const user =  state.AuthReducer.user;
	const allgroups =  state.ProgramReducer.allgroups;
	const allusers =  state.ProgramReducer.allusers;
	return { user, allusers, allgroups };
};

const mapDispatch = (dispatch) => ({
	
});

export default connect(mapState, mapDispatch)(Users);
